import React from "react";
import BidHistoryCard from "../../../bidder/Tabs/auctionFloor/components/BidHistoryCard";

interface SimpleBidHistoryCardProps {
  bid: {
    id: string;
    user_uuid: string;
    bidder_name: string;
    bidding_amount: number;
    bid_timestamp: number;
    status: "Success" | "Failed";
    meta?: {
      initial_bid?: boolean;
    };
  };
  index: number;
  currentUserUuid: string;
  isSwissAuction: boolean;
}

export default function SimpleBidHistoryCard({
  bid,
  index,
  currentUserUuid,
  isSwissAuction,
}: SimpleBidHistoryCardProps) {
  return (
    <BidHistoryCard
      key={bid.id}
      index={index}
      typeOfBid={bid.user_uuid === currentUserUuid ? "user" : "others"}
      bidsPrice={bid.bidding_amount}
      bidTimestamp={bid.bid_timestamp}
      showStatus={false}
      bidsStatusText={bid.status}
      userName={bid.bidder_name}
      bidData={bid}
      app={false}
      isSwissAuction={isSwissAuction}
    />
  );
}
